import React, { useState } from 'react';
import { X, UserPlus, Edit, Search } from '../components/Icons';
import { mockSubAccounts as initialSubAccounts, AVAILABLE_ROLES } from '../data/mockData';
import MultiSelectBase from '../components/MultiSelectBase';

const SubAccountView = () => {
  const [subAccounts, setSubAccounts] = useState(initialSubAccounts);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingAccount, setEditingAccount] = useState(null);
  const [showDisableConfirm, setShowDisableConfirm] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');

  // 过滤子账号列表
  const filteredAccounts = subAccounts.filter(account => {
    const matchSearch = !searchKeyword ||
      account.name.includes(searchKeyword) ||
      account.employeeCode.includes(searchKeyword) ||
      account.workNo.includes(searchKeyword) ||
      account.phone.includes(searchKeyword);
    const matchStatus = filterStatus === 'all' || account.status === filterStatus;
    return matchSearch && matchStatus;
  });

  // 新增子账号弹窗
  const AddSubAccountModal = ({ onClose }) => {
    const [employeeCode, setEmployeeCode] = useState('');
    const [workNo, setWorkNo] = useState('');
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [department, setDepartment] = useState('');
    const [roleId, setRoleId] = useState('');
    const [selectedBases, setSelectedBases] = useState([]);

    const handleSubmit = () => {
      if (!employeeCode || !workNo || !name || !phone || !department || !roleId || selectedBases.length === 0) {
        alert('请填写所有必填项');
        return;
      }

      const role = AVAILABLE_ROLES.find(r => r.id === roleId);
      const newAccount = {
        id: `SA${Date.now()}`,
        employeeCode,
        workNo,
        name,
        phone,
        department,
        roleId,
        roleName: role?.label || '',
        base: selectedBases.join(', '),
        status: 'active',
        createdAt: new Date().toISOString().slice(0, 10),
        lastLoginAt: '-',
      };

      setSubAccounts([newAccount, ...subAccounts]);
      onClose();
      alert(`子账号创建成功：${name}`);
    };

    return (
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[70] animate-in fade-in zoom-in duration-200">
        <div className="bg-white rounded-xl shadow-xl w-[600px] p-0 overflow-hidden flex flex-col max-h-[90vh]">
          <div className="p-6 border-b border-slate-100 flex justify-between items-center bg-white sticky top-0 z-10">
            <h3 className="text-lg font-bold text-slate-800">新增子账号</h3>
            <button onClick={onClose}>
              <X size={20} className="text-slate-400 hover:text-slate-600" />
            </button>
          </div>
          <div className="p-6 space-y-4 overflow-y-auto">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1.5">
                  用户代码 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  className="w-full border border-slate-200 rounded px-3 py-2 text-sm"
                  placeholder="例如：EMP009"
                  value={employeeCode}
                  onChange={e => setEmployeeCode(e.target.value)}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1.5">
                  工号 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  className="w-full border border-slate-200 rounded px-3 py-2 text-sm"
                  placeholder="例如：BW60001"
                  value={workNo}
                  onChange={e => setWorkNo(e.target.value)}
                />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1.5">
                  姓名 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  className="w-full border border-slate-200 rounded px-3 py-2 text-sm"
                  placeholder="请输入姓名"
                  value={name}
                  onChange={e => setName(e.target.value)}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1.5">
                  手机号 <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  className="w-full border border-slate-200 rounded px-3 py-2 text-sm"
                  placeholder="请输入手机号"
                  value={phone}
                  onChange={e => setPhone(e.target.value)}
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">
                部门 <span className="text-red-500">*</span>
              </label>
              <select
                className="w-full border border-slate-200 rounded px-3 py-2 text-sm bg-white"
                value={department}
                onChange={e => setDepartment(e.target.value)}
              >
                <option value="">请选择部门</option>
                <option value="集团总部">集团总部</option>
                <option value="平台运营中心">平台运营中心</option>
                <option value="运营部">运营部</option>
                <option value="采购部">采购部</option>
                <option value="财务部">财务部</option>
                <option value="生产部">生产部</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">
                岗位 <span className="text-red-500">*</span>
              </label>
              <select
                className="w-full border border-slate-200 rounded px-3 py-2 text-sm bg-white"
                value={roleId}
                onChange={e => setRoleId(e.target.value)}
              >
                <option value="">请选择岗位</option>
                {AVAILABLE_ROLES.filter(r => r.id !== 'admin').map(role => (
                  <option key={role.id} value={role.id}>
                    {role.label}
                  </option>
                ))}
              </select>
              {roleId && (
                <p className="mt-1 text-xs text-slate-500">
                  {AVAILABLE_ROLES.find(r => r.id === roleId)?.description}
                </p>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">
                所属基地 <span className="text-red-500">*</span>
              </label>
              <MultiSelectBase
                selectedIds={selectedBases}
                onChange={setSelectedBases}
                placeholder="请选择所属基地 (可多选)..."
              />
            </div>
          </div>
          <div className="p-4 border-t border-slate-100 bg-white flex justify-end gap-3">
            <button
              onClick={onClose}
              className="px-4 py-2 text-slate-600 text-sm font-medium hover:bg-slate-50 rounded-lg"
            >
              取消
            </button>
            <button
              onClick={handleSubmit}
              className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 flex items-center gap-2"
            >
              <UserPlus size={16} /> 创建子账号
            </button>
          </div>
        </div>
      </div>
    );
  };

  // 编辑子账号弹窗
  const EditSubAccountModal = ({ onClose, account }) => {
    const [workNo, setWorkNo] = useState(account.workNo);
    const [name, setName] = useState(account.name);
    const [phone, setPhone] = useState(account.phone);
    const [department, setDepartment] = useState(account.department);
    const [roleId, setRoleId] = useState(account.roleId);
    const [selectedBases, setSelectedBases] = useState(account.base.split(', '));

    const handleSubmit = () => {
      if (!workNo || !name || !phone || !department || !roleId || selectedBases.length === 0) {
        alert('请填写所有必填项');
        return;
      }

      const role = AVAILABLE_ROLES.find(r => r.id === roleId);
      const updatedAccount = {
        ...account,
        workNo,
        name,
        phone,
        department,
        roleId,
        roleName: role?.label || '',
        base: selectedBases.join(', '),
      };

      setSubAccounts(subAccounts.map(sa => sa.id === account.id ? updatedAccount : sa));
      onClose();
      alert(`子账号已更新：${name}`);
    };

    return (
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[70] animate-in fade-in zoom-in duration-200">
        <div className="bg-white rounded-xl shadow-xl w-[600px] p-0 overflow-hidden flex flex-col max-h-[90vh]">
          <div className="p-6 border-b border-slate-100 flex justify-between items-center bg-white sticky top-0 z-10">
            <h3 className="text-lg font-bold text-slate-800">编辑子账号</h3>
            <button onClick={onClose}>
              <X size={20} className="text-slate-400 hover:text-slate-600" />
            </button>
          </div>
          <div className="p-6 space-y-4 overflow-y-auto">
            <div className="bg-slate-50 p-3 rounded-lg border border-slate-200">
              <div className="flex items-center gap-4 text-sm">
                <span className="text-slate-500">用户代码：</span>
                <span className="font-mono text-slate-700">{account.employeeCode}</span>
                <span className="text-slate-300">|</span>
                <span className="text-slate-500">创建时间：</span>
                <span className="text-slate-700">{account.createdAt}</span>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1.5">
                  工号 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  className="w-full border border-slate-200 rounded px-3 py-2 text-sm"
                  value={workNo}
                  onChange={e => setWorkNo(e.target.value)}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1.5">
                  姓名 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  className="w-full border border-slate-200 rounded px-3 py-2 text-sm"
                  value={name}
                  onChange={e => setName(e.target.value)}
                />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1.5">
                  手机号 <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  className="w-full border border-slate-200 rounded px-3 py-2 text-sm"
                  value={phone}
                  onChange={e => setPhone(e.target.value)}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1.5">
                  部门 <span className="text-red-500">*</span>
                </label>
                <select
                  className="w-full border border-slate-200 rounded px-3 py-2 text-sm bg-white"
                  value={department}
                  onChange={e => setDepartment(e.target.value)}
                >
                  <option value="集团总部">集团总部</option>
                  <option value="平台运营中心">平台运营中心</option>
                  <option value="运营部">运营部</option>
                  <option value="采购部">采购部</option>
                  <option value="财务部">财务部</option>
                  <option value="生产部">生产部</option>
                </select>
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">
                岗位 <span className="text-red-500">*</span>
              </label>
              <select
                className="w-full border border-slate-200 rounded px-3 py-2 text-sm bg-white"
                value={roleId}
                onChange={e => setRoleId(e.target.value)}
              >
                {AVAILABLE_ROLES.filter(r => r.id !== 'admin').map(role => (
                  <option key={role.id} value={role.id}>
                    {role.label}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">
                所属基地 <span className="text-red-500">*</span>
              </label>
              <MultiSelectBase
                selectedIds={selectedBases}
                onChange={setSelectedBases}
                placeholder="请选择所属基地 (可多选)..."
              />
            </div>
          </div>
          <div className="p-4 border-t border-slate-100 bg-white flex justify-end gap-3">
            <button
              onClick={onClose}
              className="px-4 py-2 text-slate-600 text-sm font-medium hover:bg-slate-50 rounded-lg"
            >
              取消
            </button>
            <button
              onClick={handleSubmit}
              className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 flex items-center gap-2"
            >
              <Edit size={16} /> 保存修改
            </button>
          </div>
        </div>
      </div>
    );
  };

  // 停用/恢复操作
  const handleToggleStatus = (account) => {
    const newStatus = account.status === 'active' ? 'disabled' : 'active';
    setSubAccounts(subAccounts.map(sa =>
      sa.id === account.id ? { ...sa, status: newStatus } : sa
    ));
    setShowDisableConfirm(null);
    alert(`子账号 ${account.name} 已${newStatus === 'active' ? '恢复' : '停用'}`);
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-bold text-slate-800">子账号管理</h2>
        <button
          onClick={() => setShowAddModal(true)}
          className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
        >
          <UserPlus size={20} /> 新增子账号
        </button>
      </div>

      {/* 筛选栏 */}
      <div className="bg-white rounded-xl shadow-sm border border-slate-100 p-4">
        <div className="flex items-center gap-4">
          <div className="flex-1 relative">
            <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <input
              type="text"
              className="w-full pl-10 pr-4 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="搜索用户代码、工号、姓名或手机号..."
              value={searchKeyword}
              onChange={e => setSearchKeyword(e.target.value)}
            />
          </div>
          <select
            className="border border-slate-200 rounded-lg px-3 py-2 text-sm bg-white"
            value={filterStatus}
            onChange={e => setFilterStatus(e.target.value)}
          >
            <option value="all">全部状态</option>
            <option value="active">正常</option>
            <option value="disabled">已停用</option>
          </select>
        </div>
      </div>

      {/* 子账号列表 */}
      <div className="bg-white rounded-xl shadow-sm border border-slate-100 overflow-hidden">
        <table className="w-full text-left text-sm">
          <thead className="bg-slate-50 text-slate-500 border-b border-slate-100">
            <tr>
              <th className="p-4">用户代码</th>
              <th className="p-4">工号</th>
              <th className="p-4">姓名</th>
              <th className="p-4">手机号</th>
              <th className="p-4">部门</th>
              <th className="p-4">岗位</th>
              <th className="p-4">所属基地</th>
              <th className="p-4">状态</th>
              <th className="p-4">最后登录</th>
              <th className="p-4">操作</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {filteredAccounts.map(account => (
              <tr key={account.id} className={`hover:bg-slate-50 ${account.status === 'disabled' ? 'bg-slate-50' : ''}`}>
                <td className="p-4 font-mono text-slate-600">{account.employeeCode}</td>
                <td className="p-4 font-mono text-slate-600">{account.workNo}</td>
                <td className="p-4 font-medium text-slate-800">{account.name}</td>
                <td className="p-4 font-mono text-slate-600">{account.phone}</td>
                <td className="p-4 text-slate-600">{account.department}</td>
                <td className="p-4">
                  <span className="px-2 py-1 bg-blue-50 text-blue-600 rounded text-xs font-medium">
                    {account.roleName}
                  </span>
                </td>
                <td className="p-4 text-slate-600 text-xs">{account.base}</td>
                <td className="p-4">
                  <span className={`px-2 py-1 rounded text-xs font-medium ${
                    account.status === 'active'
                      ? 'bg-green-50 text-green-600'
                      : 'bg-slate-100 text-slate-500'
                  }`}>
                    {account.status === 'active' ? '正常' : '已停用'}
                  </span>
                </td>
                <td className="p-4 text-slate-500 text-xs">{account.lastLoginAt}</td>
                <td className="p-4">
                  <div className="flex gap-2">
                    <button
                      className="text-blue-600 hover:underline text-xs"
                      onClick={() => {
                        setEditingAccount(account);
                        setShowEditModal(true);
                      }}
                    >
                      编辑
                    </button>
                    {account.status === 'active' ? (
                      <button
                        className="text-orange-500 hover:underline text-xs"
                        onClick={() => setShowDisableConfirm(account)}
                      >
                        停用
                      </button>
                    ) : (
                      <button
                        className="text-green-500 hover:underline text-xs"
                        onClick={() => handleToggleStatus(account)}
                      >
                        恢复
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {filteredAccounts.length === 0 && (
          <div className="p-8 text-center text-slate-500">
            暂无匹配的子账号数据
          </div>
        )}
      </div>

      {/* 统计信息 */}
      <div className="bg-white rounded-xl shadow-sm border border-slate-100 p-4">
        <div className="flex items-center gap-6 text-sm text-slate-600">
          <span>总计：<strong className="text-slate-800">{subAccounts.length}</strong> 个子账号</span>
          <span>正常：<strong className="text-green-600">{subAccounts.filter(sa => sa.status === 'active').length}</strong> 个</span>
          <span>已停用：<strong className="text-slate-500">{subAccounts.filter(sa => sa.status === 'disabled').length}</strong> 个</span>
        </div>
      </div>

      {showAddModal && <AddSubAccountModal onClose={() => setShowAddModal(false)} />}
      {showEditModal && editingAccount && (
        <EditSubAccountModal
          onClose={() => {
            setShowEditModal(false);
            setEditingAccount(null);
          }}
          account={editingAccount}
        />
      )}
      {showDisableConfirm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[70] animate-in fade-in zoom-in duration-200">
          <div className="bg-white rounded-xl shadow-xl w-[400px] p-6">
            <h3 className="text-lg font-bold text-slate-800 mb-4">确认停用</h3>
            <p className="text-sm text-slate-600 mb-6">
              确定要停用子账号「{showDisableConfirm.name}」吗？停用后该用户将无法登录系统。
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowDisableConfirm(null)}
                className="px-4 py-2 text-slate-600 text-sm font-medium hover:bg-slate-50 rounded-lg"
              >
                取消
              </button>
              <button
                onClick={() => handleToggleStatus(showDisableConfirm)}
                className="px-4 py-2 bg-orange-600 text-white text-sm font-medium rounded-lg hover:bg-orange-700"
              >
                确认停用
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubAccountView;
